import $ from 'jquery';
import isMobile from '../util/isMobile';
import ProgressBar from 'progressbar.js';
import visible from '../util/visible';

export default {
  init() {
    $('.about-video_inner').click(function () {
      if ($(this).hasClass('is-active')) {
        $('.about-video_video').get(0).pause();
      } else {
        $('.about-video_video').get(0).play();
        setTimeout(function () {
          $('.about-video_pause').fadeOut();
        }, 3000);
      }
      $(this).toggleClass('is-active');
    });
    $('.about-video_inner').hover(function () {
      $('.about-video_pause').fadeIn();
      setTimeout(function () {
        $('.about-video_pause').fadeOut();
      }, 2000);
    });

    $(document).ready(function ($) {

      // eslint-disable-next-line
      let cultureLoader = new ProgressBar.Circle(progress, {
        strokeWidth: 6,
        easing: 'easeInOut',
        duration: 0,
        color: '#fe9900',
        trailColor: '#eee',
        trailWidth: 1,
        svgStyle: null,
      });

      // mouse tracking
      document.addEventListener('mousemove', moveMouse);
      let cursor = $('#progress');
      let mouse = {x: -100, y: -100}; //mouse.x, mouse.y
      function moveMouse(e) {
        mouse.x = e.clientX + -12;
        mouse.y = e.clientY + -8;
        // Move the cursor
        $(cursor).css(
          'left',
          mouse.x + 'px'
        );
        $(cursor).css(
          'top',
          mouse.y + 'px'
        );
      }

      function horizontal() {
        if (!isMobile) {
          var sidewaysWidth = ($('.sideways').width());
          var sectionWidth = $('.about-culture .culture-sections li').width();
          console.log('sectionWidth: ' + sectionWidth);
          var scrolled = $(document).scrollTop();
          if (scrolled >= $('.horizontal').offset().top) {

            $('.sideways').addClass('visible');

            var horizontalScrolled = $('.sideways').offset().top - $('.horizontal').offset().top;


            if (horizontalScrolled >= 1) {
              scrollProgress();
            }

            if (horizontalScrolled <= (sidewaysWidth - sectionWidth)) {

              $('.sideways').css(
                'transform',
                'translateX(' + -horizontalScrolled + 'px)'
              );

            }

          } else {
            $('.sideways').css('transform', 'translateX(0px)');
            $('.sideways').removeClass('visible');
          }
          $('.horizontal').height(
            $('.sideways').width()
          );
        }
      }

      function scrollProgress() {
        if (!isMobile) {
          $('.culture-sections li').each(function () {
            let position = $(this).offset().left;
            if (position <= 50) {
              $(this).find('.count').css(
                'transform',
                'translateX(' + (Math.abs(position) / 5) + 'px)'
              );
              $(this).find('.text h3').css(
                'transform',
                'translateX(' + (Math.abs(position) / 4) + 'px)'
              );
              $(this).find('.text p').css(
                'transform',
                'translateX(' + (Math.abs(position) / 3) + 'px)'
              );
              $(this).next('li').find('.prev-title .arrow').css(
                'width',
                '' + (Math.abs(position) / 7) + 'px'
              );
            } else {
              // not used
            }
          });

          let position = Math.abs($('.culture-sections').offset().left);
          let width = $('.sideways').width();
          let percentage = (position / width * 100).toFixed(0);
          if (percentage >= 100) {
            $('#progress, .horizontal').fadeOut();
          } else if (percentage <= 99 && percentage >= 1) {
            $('#progress, .horizontal').fadeIn();
          }
          if (percentage <= 100 && percentage >= 0) {
            let progress = (position / width);
            cultureLoader.animate(progress);  // Number from 0.0 to 1.0
            console.log('progress: ' + progress);
            $(this).find('.count').css(
              'transform',
              'translateX(' + (position / 5) + 'px)'
            );
            $(this).find('.text h3').css(
              'transform',
              'translateX(' + (position / 4) + 'px)'
            );
            $(this).find('.text p').css(
              'transform',
              'translateX(' + (position / 3) + 'px)'
            );
            $(this).find('.text').css(
              'opacity',
              '' + (position + 500) + '%'
            );
            $(this).next('li').find('.prev-title .arrow').css(
              'width',
              '' + (position / 7) + 'px'
            );

          } else {
            // null
          }
        }
      }

      $(document).on('scroll', function () {
        if (visible($('.about-culture'))) {
          if (!isMobile) {
            horizontal();
          }
        } else {
          $('#progress').fadeOut();
        }
      });

      $('.member').each(function () {
        $(this).fadeOut();
      });
      departmentChange('crew');

      function departmentChange(department) {
        $('.member').removeClass('is-active').fadeOut();
        $('.department').removeClass('is-active');
        $('.' + department).addClass('is-active');
        $('.' + department).fadeIn().addClass('is-active');
      }

      $('.department').click(function () {
        let department = $(this).data('department');
        departmentChange(department);
      });
    });
  },
};
